import { render, staticRenderFns } from "./addSupplierForm.vue?vue&type=template&id=30b27f25&"
import script from "./addSupplierForm.vue?vue&type=script&lang=js&"
export * from "./addSupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports